import request from '@/utils/request'

export function getByParam(params) {
    return request({
        url: 'api/carInspectionBusiness/getBusinessByParam',
        method: 'get',
        params
    })
}

export function getBusinessListByType(params) {
    return request({
        url: 'api/carInspectionBusiness/getBusinessListByType',
        method: 'get',
        params
    })
}


export default {getByParam, getBusinessListByType}
